import { fromJS, Map } from 'immutable';

import {
  TOGGLE_COLLAPSED_NAV,
  WINDOW_WIDTH,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  TOGGLE_APP_ERROR,
  APP_READY,
  SAVE_SETTING,
  SET_AUTH_USER,
  CHANGE_SEARCH,
  SHOW_APPLAUSE,
  HIDE_APPLAUSE,
  CHANGE_SETTING,
  LOAD_MODERATE_COUNT_SUCCESS,
  UPDATE_CREDENTIAL_SUCCESS,
  UPDATE_EVENT_SUCCESS,
  SET_MODERATED_COUNT,
  SET_CREDENTIAL_MODERATE_COUNT_SOCKET,
  SET_EVENT_MODERATE_COUNT_SOCKET,
} from 'constants/ActionTypes';
import { NAV_STYLE, NAV_STYLE_FIXED } from 'constants/ThemeSetting';
import { getDefaultConfigs } from 'util/settingConfigs';

const initialSettings = fromJS({
  moderateCount: {},
  userState: {},
  navCollapsed: true,
  navStyle: NAV_STYLE_FIXED,
  loader: false,
  pathname: '',
  width: window.innerWidth,
  isDirectionRTL: false,
  isAppReady: false,
  showApplause: false,
  search: '',
  appError: {
    isVisible: false,
    errorCode: null,
    errorContent: null,
  },
});

const settingsReducer = (state = initialSettings, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return state.merge(
        fromJS({
          pathname: action.payload.location.pathname,
          search: '',
          navCollapsed: false,
          appError: {
            isVisible: false,
          },
        }),
      );
    case APP_READY:
      return state.set('isAppReady', true);
    case TOGGLE_COLLAPSED_NAV:
      return state.set('navCollapsed', action.navCollapsed);
    case WINDOW_WIDTH:
      return state.set('width', action.width);
    case NAV_STYLE:
      return state.set('navStyle', action.navStyle);
    case ON_SHOW_LOADER:
      return state.set('loader', true);
    case ON_HIDE_LOADER:
      return state.set('loader', false);
    case TOGGLE_APP_ERROR:
      if (state.getIn(['appError', 'isVisible'])) {
        return state.set(
          'appError',
          fromJS({
            isVisible: false,
            errorCode: null,
            errorContent: null,
          }),
        );
      } else {
        return state.set(
          'appError',
          fromJS({
            isVisible: true,
            errorCode: action.errorCode,
            errorContent: action.errorContent,
          }),
        );
      }
    case SET_AUTH_USER:
      return state.set('userState', fromJS(getDefaultConfigs(action.user.state)));
    case SAVE_SETTING:
      if (action.values) {
        const keys = action.values.key.split('.');
        const isMap = Map.isMap(state.getIn(['userState', ...keys]));

        if (!isMap) {
          state = state.setIn(['userState', ...keys], fromJS(action.values.value));
          return state;
        }

        return state.setIn(
          ['userState', ...keys],
          state.getIn(['userState', ...keys])
            ? state.getIn(['userState', ...keys]).merge(fromJS(action.values.value))
            : fromJS(action.values.value),
        );
      }
      return state;
    case CHANGE_SETTING:
      if (typeof action.path === 'string') {
        return state.setIn(['userState', action.path], fromJS(action.value));
      } else {
        return state.setIn(['userState', ...action.path], fromJS(action.value));
      }
    case CHANGE_SEARCH:
      return state.set('search', action.search);
    case SHOW_APPLAUSE:
      return state.set('showApplause', true);
    case HIDE_APPLAUSE:
      return state.set('showApplause', false);
    case SET_CREDENTIAL_MODERATE_COUNT_SOCKET: {
      return state.setIn(['moderateCount', 'credentials'], action.payload.count);
    }
    case SET_EVENT_MODERATE_COUNT_SOCKET: {
      return state.setIn(['moderateCount', 'events'], action.payload.count);
    }
    case LOAD_MODERATE_COUNT_SUCCESS:
      return state.set('moderateCount', fromJS(action.values));
    case SET_MODERATED_COUNT:
      if (action.count === 'add') {
        return state.setIn(['moderateCount', 'credentials'], state.getIn(['moderateCount', 'credentials']) + 1);
      }
      return state;
    case UPDATE_CREDENTIAL_SUCCESS: {
      if (action.isModerate) {
        return state.setIn(['moderateCount', 'credentials'], state.getIn(['moderateCount', 'credentials']) - 1);
      }
      return state;
    }
    case UPDATE_EVENT_SUCCESS: {
      if (action.isModerate) {
        return state.setIn(['moderateCount', 'events'], state.getIn(['moderateCount', 'events']) - 1);
      }
      return state;
    }
    default:
      return state;
  }
};

export default settingsReducer;
